module.exports = __webpack_public_path__ + "static/media/hraswo_ni.47cd2d9a.ogg";